import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import iTerminal from '../../../components/TerminalTable.vue'
import { domainName, processFile } from "../../../utility/index"

export default {
    name: "DriverAuthorizationManagement",
    components: { tree, iTable, IPagination, iTerminal },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                driverNum: '',
                name: '',
                authorizeCountUpper: 300,
                authorizeCountLower: 0
            },
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "fingerGroup",
                    label: this.$t('DriverManagement.fingerGroup'),
                    align: "center",
                },
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",
                },
                {
                    prop: "name",
                    label: this.$t('common.driverName'),
                    align: "center",

                },
                {
                    prop: "authorizeCount",
                    label: this.$t('DriverManagement.authorizes'),
                    align: "center",

                }

            ],
            dialogOperateFormVisible: false,
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.driverNum = row.driverNum
                            this.fingerGroup = row.fingerGroup
                            this.dialogOperateFormVisible = true
                            this.getOperateList()
                        }
                    }
                ],
            },
            input: '',
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '112px',
            btnType: '',
            rules: {
                terminalType: [
                    { required: true, message: this.$t('common.form.terminalType'), trigger: 'change' }
                ],
                authType: [
                    { required: true, message: this.$t('DriverManagement.form.authorizePower'), trigger: 'change' }
                ]
            },
            form: {
                fingerGroup: '',
                driverNum: '',
                driverName: '',
                authType: '',
                terminalType: '',
                terminalIds: ''
            },
            terminalList: [],
            dialogVisibleTransfer: false,
            selected: [],
            formTable: {
                carId: '',
                terminalId: ''
            },
            authorizeList: [],
            authorizeHeight: '350px',
            authorizeColumns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",

                },
                {
                    prop: "name",
                    label: this.$t('common.driverName'),
                    align: "center",
                },
                {
                    prop: "isAuth",
                    label: this.$t('DriverManagement.isAuth'),
                    align: "center",
                },
                {
                    prop: "number",
                    label: this.$t('DriverManagement.number'),
                    align: "center",
                },
                {
                    prop: "authorizePowerCn",
                    label: this.$t('DriverManagement.authorizeType'),
                    align: "center",
                },
                {
                    prop: "createTime",
                    label: this.$t('common.createTime'),
                    align: "center",
                },
            ],
            authorizeOperates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'el-icon-document-add',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            console.log(row)
                            this.dialogFormVisible = true
                            this.isShow = false
                            this.btnType = 'addAuthorize'
                            this.form.fingerGroup = this.fingerGroup
                            this.form.driverNum = row.driverNum
                            this.form.driverName = row.name
                            this.form.terminalType = row.terminalType
                            this.form.terminalIds = row.terminalId
                        }
                    },
                    {
                        id: '2',
                        show: true,
                        icon: 'el-icon-delete',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.dialogOperateFormVisible = true
                            this.queryDetails(index, row)
                        }
                    }
                ],
            },
            AuthorizeCurrentPage: 1,
            AuthorizePageSize: 10,
            AuthorizeTotal: 1,
            driverNum: '',
            fingerGroup: '',
            name: '',
            isShow: true,
            delTransfer: true,
            paramsData: null,
            id: null
        }
    },
    mounted() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getDriveAuthorizaList()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getDriveAuthorizaList()
        },
        getDriveAuthorizaList() {
            let param = {
                orgId: this.id,
                driverNum: this.formInline.driverNum,
                name: this.formInline.name,
                authorizeCountUpper: this.formInline.authorizeCountUpper,
                authorizeCountLower: this.formInline.authorizeCountLower,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('DriverFingerprintFile/GET_SELECTFINGERLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getTerminalType() {
            this.$store.dispatch('TerminalCommand/GET_TERMINALTYPE', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.terminalList = res.data.data
                    }
                }
            }).catch(err => { })
        },

        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getDriveAuthorizaList()
        },
        onClear() {
            this.formInline = {
                driverNum: '',
                name: '',
                authorizeCountUpper: 300,
                authorizeCountLower: 0
            }
            this.getDriveAuthorizaList()
        },
        addSimple() {
            this.dialogFormVisible = true
            this.btnType = 'add'
            this.isShow = true
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.form.fingerGroup = this.selected[0].fingerGroup
                this.form.driverNum = this.selected[0].driverNum
                this.form.driverName = this.selected[0].name
            })
            this.getTerminalType()
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        fingerGroup: this.form.fingerGroup,
                        driverNum: this.form.driverNum,
                        driver: this.form.driverName,
                        authType: this.form.authType,
                        terminalType: this.form.terminalType,
                        terminalIds: this.form.terminalIds,
                    }
                    this.$store.dispatch('DriverFingerprintFile/GET_ISSUEFINGERTOCARLIST', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.addSuccess'))
                            this.dialogFormVisible = false;
                            this.getDriveAuthorizaList();
                            this.closeDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                fingerGroup: '',
                driverNum: '',
                driverName: '',
                authType: '',
                terminalType: '',
                terminalIds: ''
            }
        },
        closeDia() {
            this.paramsData = null
            this.form = {
                fingerGroup: '',
                driverNum: '',
                driverName: '',
                authType: '',
                terminalType: '',
                terminalIds: ''
            }
            this.dialogFormVisible = false;
        },
        getCarInfo() {
            this.dialogVisibleTransfer = true
            this.delTransfer = false
            this.$nextTick(() => {
                this.delTransfer = true
                this.paramsData = this.form.terminalType
            })
        },
        assignment() {
            this.form.terminalIds = this.checkList
            this.dialogVisibleTransfer = false
        },
        postParam(item) {
            if (item.length > 0) {
                item.map((t, index) => {
                    if (index == 0) {
                        this.checkList = t.terminalId
                    } else {
                        this.checkList = this.checkList + ',' + t.terminalId
                    }
                })
            } else {
                this.checkList = ''
            }
        },
        getTypeMsg(val) {
            console.log(val)
            this.form.terminalType = val
        },
        handleClose() {
            this.dialogVisibleTransfer = false
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportFingerList?orgId=${this.id}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}&authorizeCountUpper=${this.formInline.authorizeCountUpper}&authorizeCountLower=${this.formInline.authorizeCountLower}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportFingerList?orgId=${this.id}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}&authorizeCountUpper=${this.formInline.authorizeCountUpper}&authorizeCountLower=${this.formInline.authorizeCountLower}`
                    location.href = url
                }
            }
        },

        getOperateList() {
            let param = {
                orgId: this.id,
                carId: this.formTable.carId,
                terminalId: this.formTable.terminalId,
                driverNum: this.driverNum,
                fingerGroup: this.fingerGroup,
                pageNum: this.AuthorizeCurrentPage,
                pageSize: this.AuthorizePageSize,
            }
            this.$store.dispatch('DriverFingerprintFile/GET_SELECTALLFINGERBYCAR', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.authorizeList = res.data.data.list
                        this.$refs.AuthorizePage.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        closeOperateDia() {
            this.$refs.AuthorizePage.CommandCurrentPage = 1
            this.AuthorizeCurrentPage = 1
            this.dialogOperateFormVisible = false
        },
        Search() {
            this.AuthorizeCurrentPage = 1
            this.getOperateList()
        },
        Clear() {
            this.formTable = {
                carId: '',
                terminalId: ''
            },
                this.getOperateList()
        },
        handleAuthorizeChange(val) {
            this.select = val
        },
        changeAuthorizeSize(item) {
            this.AuthorizePageSize = item.pageSize
            this.AuthorizeCurrentPage = item.pageNum
            this.getOperateList();
        },
        queryDetails(index, row) {
            console.log(row)
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = {
                        terminalId: row.terminalId,
                        number: row.number
                    }
                    this.$store.dispatch('AuthorizationManagement/GET_DELETEAUTHORIZEMANGER', param).then(response => {
                        if (response.data.code == 200) {
                            this.getOperateList()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },

        down() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportAllFingerByCar?orgId=${this.id}&driverNum=${this.driverNum}&fingerGroup=${this.fingerGroup}&carId=${this.formTable.carId}&terminalId=${this.formTable.terminalId}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportAllFingerByCar?orgId=${this.id}&driverNum=${this.driverNum}&fingerGroup=${this.fingerGroup}&carId=${this.formTable.carId}&terminalId=${this.formTable.terminalId}`
                    location.href = url
                }
            }
        },

        handleSelectionChange(val) {
            console.log(val)
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getDriveAuthorizaList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}